<ng-container *ngTemplateOutlet="alwaysVisible() || visible() ? visibleTpl : hiddenTpl" />

<ng-template #visibleTpl>
  <tr>
    @if (selectable()) {
      <td
        (click)="
          !disabled() &&
            (selectionSource()
              ? selectionSource()?.toggle(row())
              : rowSelect.emit(!selectedState()));
          $event.stopPropagation()
        "
        [attr.data-cy]="'datatable:row:' + index() + ':cell:select'"
        class="selection-cell"
      >
        <div class="cell-body">
          @if (selectionCellTemplate()) {
            <ng-container
              *ngTemplateOutlet="selectionCellTemplate(); context: selectionCellContext()"
            />
          }
          @if (!selectionCellTemplate()) {
            <rt-checkbox
              [disabled]="disabled()"
              [checked]="selectedState()"
              (valueChange)="
                selectionSource() ? selectionSource()?.toggle(row()) : rowSelect.emit(!!$event)
              "
            />
          }
        </div>
      </td>
    }
    @for (
      columnId of columnIds();
      track trackByColumnId(colIndex, columnId);
      let colIndex = $index
    ) {
      <td
        class="data-cell"
        [attr.data-cy]="'datatable:row:' + (index() + 1) + ':cell:' + columnId"
        (click)="rowDetailsTemplate() && toggleDetailsRow()"
      >
        <div class="cell-body">
          @if (!cellFactories()[columnId]) {
            <ng-container
              [ngTemplateOutlet]="cellTemplateMap()[columnId] || defaultCellTemplate()"
              [ngTemplateOutletContext]="cellsContexts()[columnId]"
            />
          }
          @if (cells()[colIndex] | rtToObservable | async; as cell) {
            <ng-container
              [rtComponentOutlet]="cell?.component ?? null"
              [rtComponentOutletInputs]="$safeNavigationMigration(cell?.inputs)"
              [rtComponentOutletOutputs]="$safeNavigationMigration(cell?.outputs)"
              [rtComponentOutletContent]="$safeNavigationMigration(cell?.content)"
            />
          }
        </div>
      </td>
    }
    @if (rowDetailsTemplate()) {
      <td (click)="toggleDetailsRow()" class="cursor-pointer">
        <div class="cell-body">
          <rt-icon [name]="detailsVisible() ? 'keyboard-arrow-up' : 'keyboard-arrow-down'" />
        </div>
      </td>
    }
  </tr>
  @if (rowDetailsTemplate() && detailsVisible()) {
    <tr>
      <td
        [attr.colspan]="columnIds().length + (selectable() ? 1 : 0) + 1"
        class="no-padding details-row"
      >
        <ng-container
          [ngTemplateOutlet]="rowDetailsTemplate()"
          [ngTemplateOutletContext]="{ row: this.row() }"
        />
      </td>
    </tr>
  }
</ng-template>

<ng-template #hiddenTpl>
  <tr #hiddenEl>
    <td
      [attr.colspan]="columnIds().length + (selectable() ? 1 : 0)"
      [style.verticalAlign]="'middle'"
      [style.padding]="'1rem'"
      [style.height]="notVisibleItemHeight()"
    >
      <rt-placeloader [style.height]="'100%'" [style.width]="'30%'" class="disable-animations" />
    </td>
  </tr>
</ng-template>
